import Button from 'lj_shared/button/button';
import React from 'react';

const styles = require('./Navbar.module.scss');

interface Item {
  label: string;
}

export interface Props {
  active: Item;
  companyId: number;
  currentUserCompanyId: number;
  items: Item[];
  onClick: Function;
}

export default function Navbar({ active, companyId, currentUserCompanyId, items, onClick }: Props) {
  const renderItem = (item: Item) => {
    const { label } = item;
    const isActive = item === active;
    const navItemStyle = isActive ? styles.selectedNavItem : styles.navItem;

    return (
      <button
        className={navItemStyle}
        key={label}
        onClick={() => onClick(item)}
        role='tab'
        aria-selected={isActive}
        aria-current={isActive ? 'page' : undefined}
        aria-label={`${label} tab`}
      >
        {label}
      </button>
    );
  };

  return (
    <nav className={styles.navBar} role='navigation' aria-label='Company page navigation'>
      <div className={styles.navBarInner}>
        <div className={styles.navSection} role='tablist' aria-label='Company page tabs'>
          {items.map(renderItem)}
        </div>
        {currentUserCompanyId === companyId && (
          <Button
            isButton={false}
            buttonUrl={window.Routes.company_edit()}
            buttonColor='ripePlum'
            buttonSize='small'
            aria-label='Edit company page'
          >
            Edit
          </Button>
        )}
      </div>
    </nav>
  );
}
